type ApiErrorShape = {
  response?: {
    data?: {
      message?: string;
      errors?: Record<string, string[]>;
    };
  };
};

/**
 * Extracts a human-readable message from an Axios error.
 * Priority: first validation field error → top-level message → network fallback.
 */
export function extractApiError(
  err: unknown,
  networkFallback = 'Something went wrong. Please try again.'
): string {
  const data = (err as ApiErrorShape)?.response?.data;
  if (!data) {
    return networkFallback;
  }

  if (data.errors) {
    const first = Object.values(data.errors)[0]?.[0];
    if (first) {
      return first;
    }
  }

  return data.message ?? networkFallback;
}
